const Images={
    Resume: require('./SandeepResume.pdf'),
    Rimg1: require('./SandeepResume-1.jpg'),
    Rimg2: require('./SandeepResume-2.jpg'),
    Rimg3: require('./SandeepResume-3.jpg'),
    Rimg4: require('./SandeepResume-4.jpg'),
    Rimg5: require('./SandeepResume-5.jpg'),
    DataManagement: require('./frontend.jpg'),
    Frontend: require('./2150062008-1.jpg'),
    Backend: require('./3642-1.jpg'),
    Illustration_Frontend: require('./freepik__background__61590.png'),
    Partners: {
        Partner_One: require('./partner-1.jpg'),
        Partner_Two: require('./partner-2.jpg'),
        Partner_Three: require('./partner-3.jpg'),
        Partner_four: require('./review-5.webp'),
    },
    git_background: require('./2150248019.jpg'),
    sandeep_one: require('./sandeep_img1.jpg'),
    form_background: require('./vadim-shevyrin-xsTDS2URj6c-unsplash.jpg'),
    // resumedoc: require')

}
export default Images;